import React, { useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";

import { registerFormModel } from "../../../models";
import { keyIcon, keyIconC } from "../../../assets";
import { setRegister } from "../../../redux/slices/registerSlice";
import { FormTemplate } from "../../templates";

import * as yup from "yup";
import "yup-phone";
import YupPassword from "yup-password";
import { addEndpoint, api, apiUrls } from "../../../services/apiService";
import { setAlert } from "../../../redux/slices/alertSlice";
import { useTheme } from "@mui/material";
YupPassword(yup);

export const RegFormSection = ({ onClickNext }) => {
  const dispatch = useDispatch();
  const regData = useSelector((state) => state.register);
  const theme = useTheme();

  const [isLoading, setIsLoading] = useState(false);

  const validateData = async (values) => {
    try {
      const response = await api.post(
        apiUrls.validateData + addEndpoint([values.email, values.phoneNumber])
      );
      if (response.data.status) {
        await sendOtp(values);
      } else {
        dispatch(
          setAlert({
            message: response?.data["error_string"],
            isOpen: true,
          })
        );
        setIsLoading(false);
      }
    } catch (error) {
      dispatch(
        setAlert({
          message: error.message,
          isOpen: true,
        })
      );
      setIsLoading(false);
    }
  };

  const sendOtp = async (values) => {
    try {
      const response = await api.post(
        apiUrls.sendOtp +
          addEndpoint([values.idNumber, values.phoneNumber, values.email])
      );
      if (response.data.status) {
        dispatch(setRegister(values));
        setIsLoading(false);
        onClickNext();
      } else {
        dispatch(
          setAlert({
            message: response?.data["message"],
            isOpen: true,
          })
        );
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      dispatch(
        setAlert({
          message: error.message,
          isOpen: true,
        })
      );
      setIsLoading(false);
    }
  };

  const validationSchema = yup.object({
    name: yup.string().required("Nama wajib diisi"),
    idNumber: yup
      .string()
      .required("Nomor e-KTP wajib diisi")
      .min(16, "Nomor e-KTP tidak valid")
      .max(16, "Nomor e-KTP tidak valid"),
    email: yup
      .string()
      .email("Masukkan email yang valid")
      .required("Email wajib diisi"),
    phoneNumber: yup
      .string()
      .phone("ID", true, "Nomor telepon tidak valid")
      .matches(/^[0-9]+$/, "Nomor telepon hanya boleh angka")
      .min(10, "Nomor telepon tidak valid")
      .required("Nomor telepon wajib diisi"),
    password: yup
      .string()
      .required("Password wajib diisi")
      .min(8, "Password minimal 8 karakter")
      .max(16, "Password maksimal 16 karakter"),
    confirmPassword: yup
      .string()
      .required("Konfirmasi password wajib diisi")
      .oneOf([yup.ref("password"), null], "Password tidak sama"),
  });

  const formProps = useFormik({
    validationSchema: validationSchema,
    initialValues: regData,
    onSubmit: async (values) => {
      setIsLoading(true);
      validateData(values);
    },
  });

  return (
    <FormTemplate
      formProps={formProps}
      icon={theme.palette.mode === "dark" ? keyIcon : keyIconC}
      isLoading={isLoading}
      formModel={registerFormModel}
      title="Buat Akun Kamu"
      buttonText="Berikutnya"
    />
  );
};

RegFormSection.propTypes = {
  onClickNext: PropTypes.func,
};
